export default __webpack_public_path__ + "static/media/White-circleCorrect.47713184.svg";